import { TunaTheme, useTunaColorScheme } from '@tunasong/ui-lib'
import type { ComponentType, FC } from 'react'
import { Suspense } from 'react'
import TunaGlobalStyles from './app-global-styles.js'

export interface PublicContainerProps {
  component: ComponentType
}

/**
 * The shell for pages opened by people without an account, such as the rider venue link (`/r/{token}`).
 *
 * Deliberately NOT `AppContainer auth={false}`: that still mounts `VendorServices` (support chat,
 * analytics, error reporting), the websocket, web push, the release notes and the plugin repository.
 * Each loads a third-party script or opens a connection, and the analytics and error reporting would
 * record the page URL, which here carries a live credential. This mounts the theme and the page only.
 * The Redux `Provider` above every route (`main.tsx`) still supplies the config.
 */
export const PublicContainer: FC<PublicContainerProps> = ({ component: Component }) => {
  const { colorScheme } = useTunaColorScheme()
  return (
    <TunaTheme colorScheme={colorScheme}>
      <TunaGlobalStyles />
      {/* No spinner: the page draws its own skeleton as soon as its chunk arrives (venue link spec, Loading) */}
      <Suspense fallback={null}>
        <Component />
      </Suspense>
    </TunaTheme>
  )
}

export default PublicContainer
